import React from "react";
import {
  Row,
  Input,
  Form,
  Select,
  Col,
  message,
  Upload,
  Avatar,
  DatePicker,
  Radio,
  Spin,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { UserRound } from "lucide-react";
import { FONT, isEspotive } from "constants/index";

const dateFormat = "DD/MM/YYYY";

const getProfileOptions = (roleRedux) => {
  if (roleRedux == "ADMIN") {
    return [
      { value: "ADMIN", label: "Administrador" },
      { value: "USER", label: "Aluno" },
      { value: "USER_ADMIN", label: "Professor" },
      { value: "ADMIN_CUSTOMER", label: "Cliente" },
    ];
  }
  if (roleRedux == "ADMIN_CUSTOMER") {
    return [
      { value: "USER", label: "Aluno" },
      { value: "USER_ADMIN", label: "Professor" },
    ];
  }
  if (roleRedux == "USER_ADMIN") {
    return [{ value: "USER", label: "Aluno" }];
  }
  return [];
};

const UsersDrawerForm = ({
  form,
  editId,
  roleRedux,
  imgAvatar,
  loadingAvatar,
  loadingDrawer,
  showStepBoot,
  onAvatarChange,
  beforeUpload,
  dummyRequest,
  onSelectBoot,
}) => {
  return (
    <Spin spinning={loadingDrawer}>
      <Form form={form} layout="vertical">
        <Row gutter={16} style={{ textAlign: "center", marginBottom: "30px" }}>
          <Col span={24}>
            <Upload
              customRequest={dummyRequest}
              beforeUpload={beforeUpload}
              onChange={onAvatarChange}
              showUploadList={false}
            >
              {loadingAvatar ? (
                <LoadingOutlined />
              ) : (
                <Avatar
                  src={imgAvatar}
                  icon={<UserRound size={120} />}
                  size={120}
                />
              )}
            </Upload>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="name"
              label={<span style={{ fontFamily: FONT }}>Nome</span>}
              rules={[
                { required: true, message: "É necessário informar o nome" },
              ]}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="tipeUser"
              label={<span style={{ fontFamily: FONT }}>Perfil</span>}
              rules={[
                { required: true, message: "É necessário informar o perfil" },
              ]}
            >
              <Select allowClear options={getProfileOptions(roleRedux)} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="gender"
              label={<span style={{ fontFamily: FONT }}>Sexo</span>}
              rules={[
                { required: true, message: "É necessário informar o sexo" },
              ]}
            >
              <Select
                allowClear
                options={[
                  { value: "MALE", label: "Masculino" },
                  { value: "FEMALE", label: "Feminino" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="birthDate"
              label={
                <span style={{ fontFamily: FONT }}>Data de Nascimento</span>
              }
              rules={[
                {
                  required: true,
                  message: "É necessário informar a data de nascimento.",
                },
              ]}
            >
              <DatePicker
                style={{ fontFamily: FONT, width: "100%" }}
                placeholder={""}
                format={dateFormat}
                suffixIcon={null}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={editId != null ? 24 : 12}>
            <Form.Item
              name="email"
              label={<span style={{ fontFamily: FONT }}>E-mail</span>}
              rules={[
                { required: true, message: "É necessário informar o e-mail" },
              ]}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
          {editId == null && (
            <Col xs={24} md={12}>
              <Form.Item
                name="password"
                label={<span style={{ fontFamily: FONT }}>Senha</span>}
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a senha",
                  },
                ]}
              >
                <Input style={{ fontFamily: FONT }} />
              </Form.Item>
            </Col>
          )}
        </Row>

        {isEspotive() == true && (
          <Row gutter={16} justify="center">
            <Col>
              <Form.Item name="isBoot">
                <Radio.Group
                  options={[
                    { label: "Método Unique", value: false },
                    { label: "Iniciação", value: true },
                  ]}
                  defaultValue={false}
                  optionType="button"
                  buttonStyle="solid"
                  onChange={(e) => onSelectBoot(e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        {showStepBoot && (
          <>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ fontFamily: FONT }}>Agachamento</span>}
                  name="stepBoot1"
                >
                  <Radio.Group
                    options={[
                      { label: "Fase 1", value: 1 },
                      { label: "Fase 2", value: 2 },
                      { label: "Fase 3", value: 3 },
                      { label: "Fase 4", value: 4 },
                    ]}
                    defaultValue={1}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ fontFamily: FONT }}>Hang Clean</span>}
                  name="stepBoot2"
                >
                  <Radio.Group
                    options={[
                      { label: "Fase 1", value: 1 },
                      { label: "Fase 2", value: 2 },
                      { label: "Fase 3", value: 3 },
                      { label: "Fase 4", value: 4 },
                    ]}
                    defaultValue={1}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ fontFamily: FONT }}>Pliométrico</span>}
                  name="stepBoot3"
                >
                  <Radio.Group
                    options={[
                      { label: "Fase 1", value: 1 },
                      { label: "Fase 2", value: 2 },
                      { label: "Fase 3", value: 3 },
                      { label: "Fase 4", value: 4 },
                    ]}
                    defaultValue={1}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={
                    <span style={{ fontFamily: FONT }}>
                      Dominante Quadril{" "}
                    </span>
                  }
                  name="stepBoot4"
                >
                  <Radio.Group
                    options={[
                      { label: "Fase 1", value: 1 },
                      { label: "Fase 2", value: 2 },
                      { label: "Fase 3", value: 3 },
                      { label: "Fase 4", value: 4 },
                    ]}
                    defaultValue={1}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        {isEspotive() == false && (
          <Row gutter={16} justify="center">
            <Col>
              <Form.Item name="isBoot">
                <Radio.Group
                  options={[
                    { label: "Método Adulto", value: null },
                    { label: "Método Kids", value: false },
                    { label: "Método Atleta", value: true },
                  ]}
                  defaultValue={null}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </Spin>
  );
};

export default UsersDrawerForm;
